
<ul class="controparti m0">
	<li class="{{option.isControparte ? 'unpanel' : 'panel'}}" *ngFor="let option of optionsList; let indice = index">
		<div *ngIf="!option.isControparte" class="controparte">
			<div>
				<a data-toggle="collapse" aria-expanded="true"
					(click)="openDetail(option, indice)"
					[attr.aria-controls]="labelComponent + indice" data-parent="#controparticollapse"
					class="{{activeIndex === indice ? 'accordion-collapse' : 'accordion-collapsed'}} mt-toggle"><span>Apri</span></a>
				<p class="col-xs-12 col-sm-2 button-associa">
					<button [disabled] = "!option.isAssociable" class="btn btn-primary associa" (click)="associa(option, indice)">{{labelButton}}</button>
				</p>
				<h4 class="titolo col-xs-12 col-sm-3 mt-5"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					<a data-toggle="collapse"
						(click)="openDetail(option, indice)" aria-expanded="false"
						[attr.aria-controls]="labelComponent + indice"
						data-parent="#controparticollapse">{{option.anagrafica.cognome}}
						{{option.anagrafica.nome}}</a>
				</h4>
				<h4 class="titolo col-xs-12 col-sm-3 mt-5"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					<a data-toggle="collapse"
						(click)="openDetail(option, indice)" aria-expanded="false"
						[attr.aria-controls]="labelComponent + indice"
						data-parent="#controparticollapse">{{option.anagrafica.ragioneSociale}}</a>
				</h4>
				<p class="col-xs-12 col-sm-3 matricola mt-5"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					C/F: <strong>{{option.anagrafica.codiceFiscale}}</strong>
				</p>
				<p class="col-xs-12 col-sm-3 matricola mt-5"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					P.IVA: <strong>{{option.anagrafica.partitaIva}}</strong>
				</p>
				<p class="col-xs-6 col-sm-2 matricola mt-5" *ngIf="option.anagrafica.id.startsWith('TEMP')">
					<span class="label label-success">Nuova anagrafica</span>
				</p>
        <p class="col-sm-2 matricola mt-5" *ngIf="!option.isAssociable">
          <span class="label label-danger">Da completare</span>
        </p>

			</div>
		</div>

		<!--COLLAPSE-->
		<ul class="{{activeIndex === indice ? 'collapsed' : 'collapse'}} subcontroparte" >

			<li *ngIf="associationParte && activeIndex === indice">
				<div class="container_dati_generali">

					<app-associazione-controparte-form [primariaPreselected] = "controparti.length === 0" [parte] = "option.anagrafica" [position] = "indice" [suggestedCategory] = "option.categoria" [suggestedSubjectType] = "option.tipoSoggetto"
						(onReturn)="retrieveControparte($event)"></app-associazione-controparte-form>
				</div>
			</li>

			<li *ngIf="editingParte && activeIndex === indice">
				<div class="container_dati_generali">

					<app-anagrafica-parte-form [hasDetailsAnagrafica]="option.hasDetailsAnagrafica" [parte] = "option.anagrafica" [isParteForm]="true" (parteChange)="retrieveParte($event , option )" [labelButton] = "'Modifica'"></app-anagrafica-parte-form>
				</div>
			</li>

			<li *ngIf="!editingParte && !associationParte">
				<div class="container_dati_generali">
					<app-dati-generali-anagrafiche-search  [option]="option"
						[isLegale]="isLegale" [isPartiSearch]="isPartiSearch" [isControparte]="isControparte"></app-dati-generali-anagrafiche-search>

				</div>
			</li>

			<div class="row" *ngIf="!editingParte && !associationParte">
				<p class="col-sm-3 col-sm-offset-9 col-xs-3 col-xs-offset-9">
					<button type="button" class="btn btn-primary btn-block"
						(click)="editingParte = true">Modifica
						dati</button>
				</p>
			</div>
		</ul>
	</li>
</ul>
